import {
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Box,
  Tooltip,
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  Typography,
  LinearProgress,
} from "@mui/material";
import useFetch from "hooks/useFetch";
import { Link, useParams } from "react-router-dom";
import Logo from "assets/xyloplan-logo.png";
import { useState } from "react";
import AccountCircleRoundedIcon from "@mui/icons-material/AccountCircleRounded";
import Logout from "@mui/icons-material/Logout";
import NewGroupButton from "components/project/NewGroupButton";
import { useAuth } from "contexts/AuthContext";
import _sortBy from "lodash/sortBy";
import CopyRight from "../layout/CopyRight";
import { theme } from "theme";

export const sidebarWidth = 300;

export default function Sidebar() {
  const { logOut } = useAuth();
  const { customerId } = useParams();
  const { data: customerRes, isLoading } = useFetch("/customer");
  const showAllProjects = !customerId;

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    try {
      logOut();
      window.location.reload();
    } catch (error) {
      console.error("Error during logout:", error);
    }
  };

  return (
    <Drawer
      sx={{
        width: sidebarWidth,
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          width: sidebarWidth,
          boxSizing: "border-box",
        },
      }}
      variant="permanent"
      anchor="left"
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          alignItems: "space-between",
          height: "100%",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "16px",
          }}
        >
          <a
            href="https://www.xyloplan.com/"
            style={{ height: "40px", padding: "4px 0", marginRight: "24px" }}
          >
            <img src={Logo} alt="XyloPlan Logo" style={{ height: "100%" }} />
          </a>
          <Tooltip title="Account settings">
            <IconButton
              onClick={handleClick}
              size="small"
              sx={{ ml: 2 }}
              aria-controls={open ? "account-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
            >
              <AccountCircleRoundedIcon />
            </IconButton>
          </Tooltip>
          <Menu
            anchorEl={anchorEl}
            id="account-menu"
            open={open}
            onClose={handleClose}
            onClick={handleClose}
            transformOrigin={{ horizontal: "right", vertical: "top" }}
            anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
          >
            <MenuItem onClick={handleLogout}>
              <ListItemIcon>
                <Logout fontSize="small" />
              </ListItemIcon>
              Logout
            </MenuItem>
          </Menu>
        </Box>
        <Box
          sx={{
            flexGrow: 1,
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "16px",
            }}
          >
            <Typography variant="text" color="text.secondary">
              Project Groups
            </Typography>
            <NewGroupButton />
          </Box>
          {isLoading && (
            <Box sx={{ width: "100%" }}>
              <LinearProgress />
            </Box>
          )}
          <List
            classes={{ root: "xyloplan-scrollbar" }}
            sx={{
              height: "100%",
              width: "100%",
              overflowY: "auto",
              flex: "1",
              borderTop: `1px solid ${theme.palette.divider}`,
              borderBottom: `1px solid ${theme.palette.divider}`,
            }}
          >
            <ListItem disablePadding>
              <ListItemButton
                selected={showAllProjects}
                component={Link}
                to="/"
              >
                <ListItemText
                  primary={<Typography variant="text">All Projects</Typography>}
                />
              </ListItemButton>
            </ListItem>
            {_sortBy(customerRes?.customers || [], (v) =>
              v.name.toLowerCase()
            ).map((customer) => (
              <ListItem key={customer.id} disablePadding>
                <ListItemButton
                  selected={customer.id === Number(customerId)}
                  component={Link}
                  to={`/customer/${customer.id}`}
                >
                  <ListItemText
                    primary={
                      <Typography variant="text">
                        {customer.name || "[unnamed]"}
                      </Typography>
                    }
                  />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        </Box>
        <CopyRight />
      </Box>
    </Drawer>
  );
}
